import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ViewListIcon from '@mui/icons-material/ViewList'; // #POW-80
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'; // #POW-20
import UnarchiveIcon from '@mui/icons-material/Unarchive'; // #POW-100
import { useTranslation } from "react-i18next"; // #POW-29

import { useNavigate } from "react-router-dom";

export default function SideMenuContent({ role }: {role: string }) {
  const navigate = useNavigate()

  const handleNavigate = (page:string) => {
    navigate(page)
  }
  const { t } = useTranslation();  // #POW-29
  
  let mainListItems = [] // #POW-20

  if(role == 'shop') {  // #POW-20
    mainListItems = [
      { text: t('menu.transactionsTradeIn'), icon: <HomeRoundedIcon /> , target: '/dashboard'},
      { text: t('menu.transactionsTradeInSent'), icon: <LocalShippingIcon /> , target: '/transactions-sent'},
    ];
  } else {  
    mainListItems = [
      { text: t('menu.incomingTransactions'), icon: <HomeRoundedIcon /> , target: '/dashboard'},
      { text: t('menu.allTransactions'), icon: <ViewListIcon /> , target: '/all-transactions'}, // #POW-80
      { text: t('menu.chechedInTransactions'), icon: <AssignmentTurnedInIcon /> , target: '/transactions-checked-in'},
      { text: t('menu.exportArchive'), icon: <UnarchiveIcon /> , target: '/exports'}, // #POW-100
    ];
  }

  /**
   * Check if the current route is the active one
   * @param url 
   * @returns 
   */
  const isActiveRoute = (url:string) => {
		const active = 
      url === "/"
        ? window.location.pathname === url
        : window.location.pathname.startsWith(`${url}`)
    return active
  }

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}  onClick={() => handleNavigate(item.target)}>
            <ListItemButton selected={isActiveRoute(item.target)}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
